export default function ({ redirect, store, app }) {
  if (!store.state.cms.configuration.allowPurchaseWithoutRegistration) {
    return redirect(app.localePath('/'))
  }
  if (!store.state.cart.isCheckoutAsGuest) {
    return redirect(app.localePath('cart'))
  }
  return Promise.resolve()
}
